module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "booktitle"
  }, [_c('em', [_vm._v("FIRST BLUE")])]), _vm._v(" "), _c('p', {
    staticClass: "indenttitle"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/copy.jpg"
    }
  }), _vm._v(" THE STORY OF")]), _vm._v(" "), _c('p', {
    staticClass: "indenttitle"
  }, [_vm._v("              WORLD WAR II ACE")]), _vm._v(" "), _c('p', {
    staticClass: "indenttitle"
  }, [_vm._v("          BUTCH VORIS")]), _vm._v(" "), _c('p', {
    staticClass: "indenttitle"
  }, [_vm._v("     AND THE CREATION OF")]), _vm._v(" "), _c('p', {
    staticClass: "indenttitle"
  }, [_vm._v("THE BLUE ANGELS")]), _vm._v(" "), _c('h1', {
    staticClass: "author"
  }, [_c('em', [_vm._v("ROBERT K. WILCOX")])]), _vm._v(" "), _c('p', {
    staticClass: "indenttitlea"
  }, [_vm._v("Foreword by James Lovell")]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOMAS DUNNE BOOKS / ST. MARTIN’S PRESS")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/pub.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NEW YORK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79bc8833","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312322496_epub_tp_r1.vue
// module id = 66
// module chunks = 0